export const templateOfTextVideoBlock = `
    <p class="greytext--text">Enter an optional description here to explain the step in more detail...</p>
    <div class="video-wrapper">
        <iframe src="https://www.youtube.com/embed/U7nOMjJW86M" frameborder="0" allowfullscreen></iframe>
    </div>
`
